import { render, staticRenderFns } from "./ChildCoursesBlock.vue?vue&type=template&id=f9abbb00"
import script from "./ChildCoursesBlock.vue?vue&type=script&lang=js"
export * from "./ChildCoursesBlock.vue?vue&type=script&lang=js"
import style0 from "./ChildCoursesBlock.vue?vue&type=style&index=0&id=f9abbb00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports